import api from '@/store/api/bundle'
import * as mutationTypes from './mutation-types'

// Modules
import metrics from './metrics'
import usageHistory from './usage-history'

const initialState = () => ({
    bundle: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        bundle: state => state.bundle
    },
    actions: {
         /**
         * @param {BundleQuery} data
         * @returns {Promise<*>}
         */
        showBundle: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showBundle(data)
                commit(mutationTypes.SET_BUNDLE, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetBundle: async ({commit}) => commit(mutationTypes.RESET_BUNDLE)
    },
    modules: {
        metrics,
        usageHistory,
    },
    mutations: {
        [mutationTypes.SET_BUNDLE]: (state, data) => state.bundle = data,
        [mutationTypes.RESET_BUNDLE]: (state) => Object.assign(state, initialState())
    }
}
